import {Component, Input, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {DeviceParamLirisV3} from '../../../../../shared/classes/device/type-v3/device-param-liris-v3';
import {DeviceTypes} from '../../../../../shared/enum/devicetypes.enum';

@Component({
  selector: 'app-liris-v3',
  templateUrl: './liris-v3.component.html',
  styleUrls: ['./liris-v3.component.css']
})
export class LirisV3Component implements OnInit {
  public DeviceTypes = DeviceTypes;

  @Input('deviceParamLirisV3') deviceParamLirisV3: DeviceParamLirisV3;
  @Input('sensorType') sensorType: number = 6;
  @Input('editable') editable: boolean = true;

  constructor() {
  }

  ngOnInit() {
  }

  getStepperIndex(index: number) {
    return this.sensorType === DeviceTypes.InclinoV3 || this.sensorType === DeviceTypes.Expe ? index + 1 : index;
  }

  isLikeInclinoV3() {
    return [DeviceTypes.InclinoV3, DeviceTypes.Expe].includes(this.sensorType);
  }

}
